import { render, staticRenderFns } from "./DescargarEnvios.vue?vue&type=template&id=499f418e"
import script from "./DescargarEnvios.vue?vue&type=script&lang=js"
export * from "./DescargarEnvios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports